exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ssrs-reportviewer {\n  overflow-x: hidden;\n  overflow-y: hidden;\n  position: relative;\n  left: 0px;\n  top: 0px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/report-viewer/report-viewer.component.css
// module id = ../../../../../src/app/shared/component/report-viewer/report-viewer.component.css
// module chunks = main